<script>
	import model from "../../stores/modelStore";
	import confirmationPages from "../confirmationPages";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";
	import registrationTypes from "../../config/registrationTypes";
	import { formatDateTime, formatDate } from "../../helpers/dateHelpers";
	import { registerPageComplete } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ConfirmationSectionHeader from "../../components/ConfirmationSectionHeader.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import TextInput from "../../components/TextInput.svelte";
	import DatePicker from "../../components/DatePicker.svelte";

	export let pageName = null;
	export let pageTitle = null;
	export let nextPageLabel = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let disabled = true;
	let buttons = null;
	let signature = null;

	$model.lastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	let formattedDate = formatDate(new Date());
	let signedDate = formatDate(new Date());	

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			// These are here to fix wierd html formating bug within ThankYou page
			$model.claimantSignature = signature;
			if ($model.claimantSignature) {
				$model.signedDate = formattedDate;
			}

			$model.tellingTruth = tellingTruth ? "true" : "false";
			$model.consentAcceptance = consent ? "true" : "false";

			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log("Error trying to save confirmation.");
			} else {
				registerPageComplete(
					pageName,
					$model.contact.emailAddress,
					$model.contact.phoneNumber,
				);
				$model.surveyComplete = true;
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	// Check if there is a function to call in routes.js which will determine if a page is to be shown,
	// otherwise just show it.
	const displayComponent = (page) => {
		if (page && page.confirmationAvoid === "true") {
			// don't show this page on confirmation screen, ONLY in review
			return false;
		}

		if (
			page &&
			page.showComponent &&
			typeof page.showComponent === "function"
		) {
			return page.showComponent($model);
		}
		return true;
	};

	let tellingTruth = false;
	let consent = false;

	let signatureRequired = true;
	let disableSubmit = true;
	$model.confirmationPage = true;

	if ($model) {
		signature = $model.claimantSignature ? $model.claimantSignature : null;

		tellingTruth = $model.tellingTruth === "true";
		consent = $model.consentAcceptance === "true";		

		if ($model.signedDate) {
			let padding = "";
			let parts = $model.signedDate.split("/");
			let day = parts[0];

			// Check if the day is a single digit
			if (day.length === 1) {
				padding = "0";
			} else { 
				formattedDate = `${padding}${$model.signedDate}`
				signedDate = formattedDate;
			};
		}

		if ($model.skyDiscovery_SignedDate) {
			signedDate = $model.skyDiscovery_SignedDate;
		}
	}

	$: {
		if (
			$model.registrationType &&
			$model.registrationType === registrationTypes.types.Myself.value
		) {
			console.log("signaturerequired myself");
			signatureRequired = true;
		} else {
			if ($model.entrant && $model.entrant.emailAddress) {
				if (
					$model.entrant.emailAddress
						.toLowerCase()
						.endsWith("@shine.com.au")
				) {
					signatureRequired = false;
				}
			}
		}

		if (!signatureRequired) {
			disableSubmit = false;
		} else {
			if (tellingTruth && consent) {
				disableSubmit = false;
			} else {
				disableSubmit = true;
			}
		}
	}
</script>

<PageSection>
	<Form id="form-confirmation-" on:submit={handleSubmit}>
		<FormRow class="justify-content-center">
			<FormColumn>
				<h1 class="text-center">
					{@html projectSettings.classActionName}
				</h1>
				<h2 class="text-center">
					Please confirm your details below to complete your
					registration
				</h2>
				<p>
					Please review the information you have provided and confirm
					the information is true and correct by clicking the checkbox
					below.
				</p>
			</FormColumn>
		</FormRow>

		<div class="confirmation">
			{#each confirmationPages as page, i}
				{#if displayComponent(page)}
					<ConfirmationSectionHeader
						heading={page.confirmationHeading}
						routeId={page.routeId}
						editable={page.editable}
					></ConfirmationSectionHeader>

					<svelte:component this={page.component} {disabled} />
				{/if}
			{/each}
		</div>

		<FormRow>
			<div class="col-md-12 col-sm-12">
				<Checkbox
					required={signatureRequired}
					bind:checked={tellingTruth}
					label="I am telling the truth about the information I have completed in this Registration Form."
					id="confirmation"
				></Checkbox>
			</div>
		</FormRow>
		<FormRow>
			<div class="col-md-9 col-sm-9">
				<Checkbox
					required={signatureRequired}
					bind:checked={consent}
					label="I expressly consent to this method of acceptance in accordance with <u>s10 of the Electronic Transactions Act 2011 (WA)</u>"
					id="consentAcceptance"
				></Checkbox>
			</div>
		</FormRow>
		<FormRow>
			<FormColumn cols="8">
				<TextInput
					required={signatureRequired}
					id="signature"
					label="Claimant's signature"
					placeholder="Please type your full name"
					bind:value={signature}
				/>
			</FormColumn>
			<div class="col-md-3 col-sm-3">
				<TextInput
					id="signed-date"
					disabled={true}
					label="Date"
					value={signedDate}
				/>
			</div>
		</FormRow>
		<FormRow class="confirmation-hide">
			<FormColumn>
				<NavigationButtons
					bind:buttons
					disableNext={disableSubmit}
					{nextPageLabel}
				/>
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	:global(.confirmation .confirmation-hide) {
		display: none;
	}

	:global(.confirmation-show) {
		display: none;
	}

	:global(.confirmation .confirmation-show) {
		display: flex;
	}

	:global(
			.confirmation .confirmation-show h1,
			.confirmation .confirmation-show h2
		) {
		margin-bottom: 16px;
	}

	:global(.confirmation .confirmation-box-shadow) {
		border: 1px solid var(--color-soft);
		background-color: var(--color-white);
		box-shadow: var(--box-shadow-card);
		padding: 20px;
		margin-bottom: 26px;
	}

	:global(
			.confirmation input.form-control,
			.confirmation select.form-control
		) {
		border: 1px solid var(--color-soft);
		background-color: var(--color-white);
		height: 44px;
		line-height: 18px;
		background-image: none;
	}

	:global(.confirmation textarea.form-control) {
		border: 1px solid var(--color-soft);
		background-color: var(--color-white);
		background-image: none;
	}

	:global(.confirmation .row) {
		margin-top: 16px;
	}

	:global(.confirmation .datepicker .calendar-icon) {
		display: none;
	}
</style>
